import template from './sw-cms-block-acris-blog-author-date.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-blog-author-date', {
    template
});
